import { Injectable, InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';
export let APP_CONFIG = new InjectionToken('app.config');

export interface IAppConfig {
  apiEndpointV2: string;
  tenantEndpoint: string;
  tokenEndpoint: string;
}

@Injectable()
export class AppConfig implements IAppConfig {
  apiEndpointV2: string;
  tenantEndpoint: string;
  tokenEndpoint: string;
  private readonly blockedProductionHosts = ['yourlandlordtest.azurewebsites.net'];

  constructor() {
    if (environment.production && this.blockedProductionHosts.includes(window.location.hostname)) {
      throw new Error('You are trying to run the test environment in production mode.');
    }

    this.apiEndpointV2 = environment.apiV2;
    this.tenantEndpoint = `${environment.apiV2}/contact`;
    this.tokenEndpoint = environment.token;
  }
}
